import { Navigate } from 'react-router';
import { inferRouteObject } from 'react-router-typed-object';

import { PrivateRoute, Roles, not, or } from '@/js/libs/use-auth';

import Account from 'src/scenes/Account';
import Status from 'src/scenes/Status';

const index = true;

export const accountRouteObject = inferRouteObject({
  path: 'account',
  children: [
    { index, Component: Status.NotFound },
    { path: 'activate/:hash', Component: Account.ActivateUser },
    {
      element: <PrivateRoute roles={not(Roles.ANONYMOUS)} redirectPath='/login' />,
      children: [
        { path: 'edit-settings', Component: Account.Profile },
        // TODO: remove the redirect after 22.12.2025
        { path: 'editSettings', element: <Navigate to='../edit-settings' replace /> },
      ],
    },
    {
      element: <PrivateRoute roles={or(Roles.ADMIN, Roles.COMPANY_ADMIN)} noAccessComponent={Status.NotFound} />,
      children: [
        {
          path: 'company',
          Component: Account.Company,
          children: [
            { index, Component: Account.CompanyTab },
            { path: 'user-roles', Component: Account.CompanyUserRolesList },
          ],
        },
        {
          element: <PrivateRoute roles={not(or(Roles.SSO, Roles.POSTADMANAGER))} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'users',
              children: [
                { index, Component: Account.Users },
                { path: ':userId/edit', Component: Account.EditUser },
              ],
            },
          ],
        },
      ],
    },
  ],
});
